import { useEffect, useState } from "react";
import BankGrid from "./BankGrid";
import { CloseIcon, PlusIcon } from "./icons";

// Picks more financiers for a lead from the Send to Bank page — up to
// `remaining` more, so the lead never goes over its total cap.
export default function AddBankModal({ open, banks, remaining, max, saving, onClose, onAdd }) {
  const [picked, setPicked] = useState({});
  useEffect(() => {
    if (open) setPicked({});
  }, [open]);
  if (!open) return null;

  const pickedKeys = Object.keys(picked).filter((k) => picked[k]);
  const toggle = (key) => {
    if (!picked[key] && pickedKeys.length >= remaining) return;
    setPicked((p) => ({ ...p, [key]: !p[key] }));
  };

  return (
    <div className="overlay overlay--mail" onClick={(e) => e.target === e.currentTarget && !saving && onClose()}>
      <div className="mail-box">
        <div className="mail-box__head">
          <span className="sheet-box__icon">
            <PlusIcon stroke="#0BBDDD" />
          </span>
          <span className="sheet-box__titles">
            <span className="sheet-box__title">Add bank</span>
            <span className="sheet-box__sub">
              You can add {remaining} more (up to {max} banks per application)
            </span>
          </span>
          <button type="button" className="sheet-box__close" onClick={onClose} disabled={saving}>
            <CloseIcon />
          </button>
        </div>
        <div className="mail-box__body">
          {banks.length === 0 ? (
            <div className="history-empty">Every available bank is already on this application.</div>
          ) : (
            <BankGrid banks={banks} fins={picked} onToggle={toggle} disabled={saving} />
          )}
        </div>
        <div className="mail-box__foot">
          <button type="button" className="mail-box__cancel" onClick={onClose} disabled={saving}>
            Cancel
          </button>
          <button type="button" className="mail-box__send" onClick={() => onAdd(pickedKeys)} disabled={saving || pickedKeys.length === 0}>
            {saving ? "Adding…" : pickedKeys.length > 1 ? "Add " + pickedKeys.length + " banks" : "Add bank"}
          </button>
        </div>
      </div>
    </div>
  );
}
